import { makeStyles, shorthands, tokens } from '@fluentui/react-components';

export const useDailyHabitInterstitialStyles = makeStyles({
  container: {
    display: 'flex',
    gap: tokens.spacingHorizontalXXL,
    ...shorthands.padding(tokens.spacingVerticalXL),
    backgroundColor: tokens.colorNeutralBackground1,
  },
  containerMobile: {
    flexDirection: 'column',
    alignItems: 'center',
    textAlign: 'center',
    gap: tokens.spacingVerticalL,
  },
  imageContainer: {
    flex: '0 0 25%',
    display: 'flex',
    alignItems: 'center',
    justifyContent: 'center',
  },
  image: {
    width: '100%',
    height: 'auto',
  },
  messageContainer: {
    flex: 1,
    display: 'flex',
    flexDirection: 'column',
    gap: tokens.spacingVerticalL,
  },
  buttonContainer: {
    display: 'flex',
    gap: tokens.spacingHorizontalL,
    marginTop: tokens.spacingVerticalL,
    alignItems: 'center',
    justifyContent: 'flex-end',
  },
  buttonContainerMobile: {
    flexDirection: 'column',
    alignItems: 'stretch',
    justifyContent: 'center',
  },
  textWrapper: {
    ...shorthands.padding(
      tokens.spacingVerticalL,
      tokens.spacingHorizontalNone,
      tokens.spacingVerticalNone,
      tokens.spacingHorizontalXXL),
  },
  title: {
    fontWeight: tokens.fontWeightRegular,
    lineHeight: tokens.lineHeightBase600,
    fontSize: tokens.fontSizeBase600,
    color: tokens.colorNeutralForeground1,
    ...shorthands.margin(
      tokens.spacingVerticalNone,
      tokens.spacingHorizontalNone,
      tokens.spacingVerticalNone,
      tokens.spacingHorizontalNone),
  },
  description: {
    marginTop: tokens.spacingVerticalNone,
    fontSize: tokens.fontSizeBase400,
    fontWeight: tokens.fontWeightRegular,
    lineHeight: tokens.lineHeightBase400,
    color: tokens.colorNeutralForeground1,
  },
  notNowButton: {
    color: tokens.colorNeutralForeground1,
  },
});
